// Clipboard helper used by the PayID payment page.
// The previous bank-app deep-linking & QR encoding has been removed in favour
// of a simpler manual "PayID + amount + reference" flow.

import { log } from './logger';

/** Robust clipboard write with execCommand fallback for older WebViews. */
export const writeClipboard = async (text) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (err) { log.warn('clipboard.writeText failed, falling back to execCommand', err); }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
};
